import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { testimonials } from '../mockData';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from './ui/button';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const nextTestimonial = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-blue-600 font-semibold text-lg mb-4 tracking-wide uppercase">Testimonials</h3>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Client's <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">Feedback</span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto relative">
          <Card className="border-2 border-blue-100 shadow-2xl overflow-hidden">
            <CardContent className="p-12">
              <Quote className="w-16 h-16 text-blue-200 mb-6" />
              
              <div className="space-y-6">
                <p className="text-xl text-gray-700 leading-relaxed italic">
                  "{testimonials[currentIndex].content}"
                </p>
                
                <div className="flex items-center space-x-4 pt-6 border-t-2 border-blue-100">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center text-white font-bold text-xl">
                    {testimonials[currentIndex].name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900">{testimonials[currentIndex].name}</h4>
                    <p className="text-blue-600 font-medium">{testimonials[currentIndex].position}</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Navigation Buttons */}
          <div className="flex justify-center items-center space-x-4 mt-8">
            <Button
              onClick={prevTestimonial}
              variant="outline"
              size="icon"
              className="rounded-full w-12 h-12 border-2 border-blue-600 hover:bg-blue-50 transition-colors duration-300"
            >
              <ChevronLeft className="w-6 h-6 text-blue-600" />
            </Button>
            
            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setIsAutoPlaying(false);
                    setCurrentIndex(index);
                  }}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentIndex 
                      ? 'bg-blue-600 w-8' 
                      : 'bg-blue-200 hover:bg-blue-300'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
            
            <Button
              onClick={nextTestimonial}
              variant="outline"
              size="icon"
              className="rounded-full w-12 h-12 border-2 border-blue-600 hover:bg-blue-50 transition-colors duration-300"
            >
              <ChevronRight className="w-6 h-6 text-blue-600" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;